module.exports = __webpack_public_path__ + "static/fonts/BMYEONSUNG.30f546f.ttf";